import { ISurveyAnswerOption } from "@common/models/CMS/SurveyAnswerOption";
import { ISurveySingleAnswer } from "@common/models/SurveyConfirm";
import { ISurveyQuestionMultiOption } from "@common/models/CMS/SurveyQuestionMultiOption"
import RadioInput from "@components/general/form/RadioInput"
import Icon from "@components/general/Icon"
import { FC } from "react"

export const emojies: number[] = [1, 2, 3, 4];

interface ISurveyQuestionProps {
    singleAnswers: ISurveySingleAnswer[];
    question: ISurveyQuestionMultiOption;
    className?: string;
    onChangeSingleAnswer: (questionId: number, answer: ISurveyAnswerOption) => void;
}


export const SurveyQuestionSingleAnswer: FC<ISurveyQuestionProps> = ({ singleAnswers, question, className, onChangeSingleAnswer }) => {

    const emojiAnswers = question.bag.contentItems.find(answer => emojies.find(x => x === answer.id));

    return (
        <div className={`survey-question-single-answer col-md-1-1 col-sm-1-1${emojiAnswers ? " emoji-answers" : ""} ${className || ""} `.trim()}>
            <main className={`row spa-1 flex single-answer ${question.answerNewLine ? " new-line" : " flex-no-wrap"} flex-center flex-grow justify-between`}>
                <section className={`col-1-auto flex flex-center question-title`}>{question.text}</section>
                {emojiAnswers ? <section className="col-1-auto dot-line flex-grow" />
                    : ""}
                <section className="col-1-auto answer-items">
                    <div className="row flex spa-1 answer-items-container">
                        {
                            question.bag.contentItems.map((answer => <div
                                key={answer.id.toString()}
                                className={`col-1-${question.bag.contentItems.length}${!emojies.includes(answer.id) ? ` col-sm-1-${question.answerColumnCount}` : ""} answer-item${emojies.includes(answer.id) ? " emoji-answer-item" : ""}`}

                            >
                                <RadioInput
                                    name={question.id.toString()}
                                    id={answer.id.toString()}
                                    checked={(singleAnswers?.find(x => x.questionId === question.id)?.answerId === answer.id) || false}
                                    onChange={() => onChangeSingleAnswer(question.id, answer)}
                                    label={emojies.includes(answer.id) ? "" : answer.displayText}
                                />
                                {
                                    emojies.includes(answer.id) ? <Icon
                                        name={`icon-emoji-${answer.id}`}
                                        className={`${singleAnswers?.find(x => x.questionId === question.id)?.answerId === answer.id ? `active-${answer.id}` : ""}`}
                                    />
                                        : ""
                                }
                            </div>))
                        }
                    </div>
                </section>
            </main>
        </div>
    )
}